import * as qs from "qs"
import { omitBy } from "remeda"

export const stringifyQueryObj = <T extends Record<string, any>>(obj: T) =>
  // Remove empty strings to avoid empty query params
  qs.stringify(
    omitBy(obj, (el) => el === ""),
    { arrayFormat: "repeat" },
  )
